import exExternal from './external';

// ----------------------------------------------------------------------------

function getApi(type: string): Record<string, any> | undefined {
    const bsApi = exExternal.bootstrap[type];

    if (!bsApi) {
        console.error("Can't find bootstrap type!");
        return;
    }

    return bsApi;
}

// ----------------------------------------------------------------------------

function getInstance(type: string, element: HTMLElement): Record<string, any> | undefined {
    return getApi(type)?.getInstance(element);
}

function getCreateInstance(
    type: string,
    element: HTMLElement,
    config: Record<string, any> = {},
): Record<string, any> | undefined {
    return getApi(type)?.getOrCreateInstance(element, config);
}

// ----------------------------------------------------------------------------

function close(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.close();
}

function dispose(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.dispose();
}

function hide(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.hide();
}

function show(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.show();
}

function toggle(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.toggle();
}

function update(type: string, element: HTMLElement, config: Record<string, any> = {}): void {
    getCreateInstance(type, element, config)?.update();
}

// ----------------------------------------------------------------------------

export { getApi, getInstance, getCreateInstance, close, dispose, hide, show, toggle, update };
